import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@material-ui/core"
import {ExpandMore as ExpandMoreIcon, RemoveCircle as RemoveEmailLeadIcon} from "@material-ui/icons"
import React from "react"

import {CustomerEmailLeadRemovedActivityPayload} from "@indebted/api"

function EmailLeadRemovedActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerEmailLeadRemovedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<RemoveEmailLeadIcon style={{color: "#FF9417"}} />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>Email:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.EmailLead}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Reason:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Reason}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Agent&#39;s Email:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.AgentEmail}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {EmailLeadRemovedActivity}
